<template>
  <div class="customer-service-component">
    <div class="service-info">
      <div class="desc">{{ title }}</div>
      <div class="tool-block">
        <ym-button v-if="showConsultBtn"
                   class="item service-btn"
                   size="extra-small"
                   plain
                   round
                   @click="handleQrCodePopup"
        >
          <ym-icon name="wechat-fill" />{{ consultString }}
        </ym-button>
        <a class="item"
           :href="consumerHotLineHref"
        >
          <ym-button class="service-btn"
                     size="extra-small"
                     plain
                     round
          >
            <ym-icon name="phone-fill" />{{ telString }}
          </ym-button>
        </a>
      </div>
    </div>
    <qr-code-popup :show.sync="showQrCodePopup"
                   :title="qrCodeTitle"
                   :src="qrCode.src"
                   :hint="qrCodeHint"
    />
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import { CONSUMER_HOTLINE } from '@/utils/constant';
  import QrCodePopup from '@/components/QrCodePopup';
  import { isAppWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'CustomerService',
    components: {
      'ym-button': Button,
      QrCodePopup,
    },
    data() {
      return {
        showQrCodePopup: false,
      };
    },
    props: {
      title: {
        type: String,
        default: '联系客服',
      },
      qrCode: {
        type: Object,
        default() {
          return {};
        },
      },
      showConsultBtn: {
        type: Boolean,
        default: false,
      },
      consultString: {
        type: String,
        default: '微信客服',
      },
      qrCodeTitle: {
        type: String,
        default: '咨询微信客服',
      },
      telString: {
        type: String,
        default: '拨打电话',
      },
    },
    computed: {
      consumerHotLineHref() {
        return `tel:${CONSUMER_HOTLINE}`;
      },
      qrCodeHint() {
        if (this.qrCode.hint === '') {
          return '长按识别添加<br>微信客服给您答疑解惑';
        }
        return this.qrCode.hint;
      },
    },
    methods: {
      handleQrCodePopup() {
        if (isAppWebView()) {
          locationToAppWithRoute({
            name: 'AppQrCodeDetail',
            params: {
              qrCode: this.qrCode.src,
              hint: this.qrCodeHint,
            },
          });
          return;
        }
        this.showQrCodePopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .service-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @size-small @size-base;
    background: @color-white;
    margin-top: @size-small;
  }

  .desc {
    font-weight: @font-weight-primary;
  }

  .tool-block {
    display: flex;
    color: @color-text-base;
  }

  .item {
    &:not(:last-child) {
      margin-right: @size-small;
    }
  }

  .service-btn {
    font-size: @font-size-small;
    .ym-icon {
      margin: 0 8px 2px 0;
    }
  }

</style>
